import { QueryClient } from "@tanstack/react-query";
import type { ModalMessage } from "@/types/data.types";

export function modalHelper(queryClient: QueryClient) {
  const setModal = (newModal: string) => {
    queryClient.setQueryData(["RES-DATA"], (prevState:any) => { return {...prevState,currentModal: newModal }});
  };

  const setModalVideo = (modalVideoUrl: string) => {
    queryClient.setQueryData(["RES-DATA"], (prevState:any) => { return {...prevState,
      currentModal: "video",
      modalVideoUrl: modalVideoUrl,
    }});
  };

  const setSubdivision = (newSubdivision: string) => {
    queryClient.setQueryData(["RES-DATA"], (prevState:any) => { return {...prevState, subdivision: newSubdivision }});
  };

  const setResultModal = (newResultModal: ModalMessage) => {
    // const parsedResultModal = {header:htmlFrom(newResultModal.header), body: htmlFrom(newResultModal.body), footer: htmlFrom(newResultModal.footer)}
    queryClient.setQueryData(["RES-DATA"], (prevState:any) => { return {...prevState, resultModal: newResultModal }});
  };

  return { setModal, setModalVideo, setSubdivision, setResultModal };
}

export const fetchListingData = async (type: string, id: string) => {
  const response = await fetch(`/api/listings/${type}/${id}`);
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || "An error occurred while processing your request.");
  }
  return response.json();
};

export const fetchBlogData = async () => {
  const response = await fetch(`/api/blog`);
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || "An error occurred while processing your request.");
  }
  return response.json();
};

export const fetchDocumentsData = async (id: string) => {
  const response = await fetch(`/api/documents/${id}`);
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || "An error occurred while processing your request.");
  }
  return response.json();
};

export const postFormData = async (data: any) => {
  const response = await fetch(`/api/form`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || "An error occurred while processing your request.");
  }
  return await response.json();
};